import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { Conversation } from 'src/models';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';
import { ConversationsService } from 'src/services/conversations.service';

@Component({
  selector: 'app-conversation-chip',
  templateUrl: './conversation-chip.component.html',
  styleUrls: ['./conversation-chip.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, SharedPipesModule, RouterModule],
})
export class ConversationChipComponent implements OnInit {
  @Input() conversationId: string;

  conversation: Partial<Conversation>;

  constructor(private conversationsService: ConversationsService) {}

  async ngOnInit() {
    this.conversation = await this.conversationsService.get(this.conversationId);
  }
}
